var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('listado-acuerdos-clientes-tabla',{attrs:{"data":_vm.data,"getListaAcuerdosClientes":_vm.getListaAcuerdosClientes,"load":_vm.load,"dataInicial":_vm.dataInicial}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }